// 支付方式
export const PAYMENT_METHODS = {
  ALIPAY: 'alipay',
  WECHAT: 'wechat',
};

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.ALIPAY]: '支付宝',
  [PAYMENT_METHODS.WECHAT]: '微信支付',
};

// 商品分类
export const PRODUCT_CATEGORIES = {
  SOFA: 'sofa',
  TABLE: 'table',
  CHAIR: 'chair',
  BED: 'bed',
  CABINET: 'cabinet',
  OTHER: 'other',
};

export const CATEGORY_LABELS = {
  [PRODUCT_CATEGORIES.SOFA]: '沙发',
  [PRODUCT_CATEGORIES.TABLE]: '桌子',
  [PRODUCT_CATEGORIES.CHAIR]: '椅子',
  [PRODUCT_CATEGORIES.BED]: '床',
  [PRODUCT_CATEGORIES.CABINET]: '柜子',
  [PRODUCT_CATEGORIES.OTHER]: '其他',
};

// 订单状态
export const ORDER_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  SHIPPED: 'shipped',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: '待支付',
  [ORDER_STATUS.PAID]: '已支付',
  [ORDER_STATUS.SHIPPED]: '已发货',
  [ORDER_STATUS.COMPLETED]: '已完成',
  [ORDER_STATUS.CANCELLED]: '已取消',
};
